export function formatDate(value: string, options?: Intl.DateTimeFormatOptions) {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...options,
  }).format(new Date(value))
}

export function formatTime(value: string) {
  return new Intl.DateTimeFormat('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value))
}

export function formatDateTime(value: string) {
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  }).format(new Date(value))
}

export function humaniseRole(value: string) {
  return value
    .split('_')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ')
}

export function relativeDue(value: string) {
  const minutes = Math.round((new Date(value).getTime() - Date.now()) / 60000)
  if (minutes === 0) return 'Due now'
  if (minutes > 0 && minutes < 60) return `Due in ${minutes} min`
  if (minutes >= 60 && minutes < 1440) return `Due in ${Math.floor(minutes / 60)}h ${minutes % 60}m`
  if (minutes < 0 && minutes > -60) return `${Math.abs(minutes)} min overdue`
  if (minutes <= -60) return `${Math.floor(Math.abs(minutes) / 60)}h overdue`
  return formatDateTime(value)
}
